import apiClient from '@u/apiClient'
import { toTranslatedNamePayload } from '@u/helpers/translatableNames'
import GetFuneralHomeListController from '@/wayfinder/actions/App/Http/Controllers/FuneralHome/GetFuneralHomeListController'
import GetFuneralHomeWithPartnerListController from '@/wayfinder/actions/App/Http/Controllers/FuneralHome/GetFuneralHomeWithPartnerListController'
import GetFuneralHomeByIdController from '@/wayfinder/actions/App/Http/Controllers/FuneralHome/GetFuneralHomeByIdController'
import GetFuneralHomeActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/FuneralHome/GetFuneralHomeActivitiesByIdController'
import CreateFuneralHomeController from '@/wayfinder/actions/App/Http/Controllers/FuneralHome/CreateFuneralHomeController'
import UpdateFuneralHomePartnerController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/UpdateFuneralHomePartnerController'
import DeleteFuneralHomeController from '@/wayfinder/actions/App/Http/Controllers/FuneralHome/DeleteFuneralHomeController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
import UpdateFuneralHomeController from '@/wayfinder/actions/App/Http/Controllers/FuneralHome/UpdateFuneralHomeController'

const baseErrors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // region fetch

  async fetchFuneralHomesList({ commit }) {
    await apiClient
      .route(GetFuneralHomeListController.get())
      .then(async (response) => {
        commit('setFuneralHomesList', response.data.funeral_homes)
        commit('setFuneralHomeMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchFuneralHomesList', reason)
      })
  },

  async fetchFuneralHomesWithPartnersList({ commit }) {
    await apiClient
      .route(GetFuneralHomeWithPartnerListController.get())
      .then(async (response) => {
        commit('setFuneralHomesList', response.data.funeral_homes)
        commit('setFuneralHomeMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchFuneralHomesList', reason)
      })
  },

  async fetchFuneralHomeByID({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .route(GetFuneralHomeByIdController.get({ funeral_home: payload.id }))
      .then(async (response) => {
        await commit('setFuneralHome', response.data.funeral_home)
        await commit('setFuneralHomeMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchFuneralHomeByID', reason)
      })
  },

  async fetchNewFuneralHome({ commit }) {
    commit('setFuneralHome', {})
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .route(GetNewModelController.get({ query: { model: 'FuneralHome' } }))
      .then(async (response) => {
        await commit('setFuneralHome', response.data.FuneralHome)
        await commit('setFuneralHomeMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchNewFuneralHome', reason)
      })
  },
  fetchFuneralHomeActivitiesByFuneralHomeID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetFuneralHomeActivitiesByIdController.get({
            funeral_home: payload.funeralHome_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  storeNewFuneralHome({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })

    let formData = new FormData()

    formData.append(
      'data',
      JSON.stringify(
        toTranslatedNamePayload(payload.funeral_home, ['name', 'long_name'])
      )
    )
    if (payload.funeral_home.new_logo_file) {
      formData.append('new_logo_file', payload.funeral_home.new_logo_file)
    }

    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateFuneralHomeController.post(), formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          commit('setFuneralHomesList', response.data.funeral_homes)
          commit('setFuneralHomeMetadata', response.data.metadata)
          resolve(response)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updateFuneralHome({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })

    let formData = new FormData()

    formData.append(
      'data',
      JSON.stringify(
        toTranslatedNamePayload(payload.funeral_home, ['name', 'long_name'])
      )
    )

    if (payload.funeral_home.new_logo_file) {
      formData.append('new_logo_file', payload.funeral_home.new_logo_file)
    }

    return new Promise((resolve, reject) => {
      apiClient
        .formRoute(
          UpdateFuneralHomeController.put({ funeral_home: payload.id }),
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then((response) => {
          commit('setFuneralHomesList', response.data.funeral_homes)
          commit('setFuneralHomeMetadata', response.data.metadata)
          resolve(response)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async updateFuneralHomePartner({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    // console.log(payload)

    await apiClient
      .route(
        UpdateFuneralHomePartnerController.put({
          funeral_home_partner: payload.id
        }),
        payload.funeralHomePartner
      )
      .then(async (response) => {
        if (response.status === 201) {
          commit('setFuneralHomesList', response.data.funeral_homes)
          commit('setFuneralHomeMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('error updateFuneralHome', reason)
      })
  },
  // endregion

  // region delete
  async deleteFuneralHomeById({ commit }, payload) {
    // console.log(payload.id, 'action deleteFuneralHomeById')
    await apiClient
      .route(
        DeleteFuneralHomeController.delete.delete({ funeral_home: payload.id })
      )
      .then(async (response) => {
        if (response.status === 200) {
          commit('setFuneralHomesList', response.data.funeralHomes)
          commit('setFuneralHomeMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('deleteFuneralHomeById', reason)
      })
  },
  // endregion

  // region undoDelete
  async undoDeleteFuneralHomeById({ commit }, payload) {
    await apiClient
      .route(DeleteFuneralHomeController.undo.get({ id: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          commit('setFuneralHomesList', response.data.funeralHomes)
          commit('setFuneralHomeMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('undoDeleteItemById', reason)
      })
  }
  // endregion
}
